import React from 'react';
import { Typography, Space } from 'antd';
import PaymentList from '../../features/payment/components/PaymentList';

const { Title } = Typography;

const PaymentListPage: React.FC = () => {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Title level={2}>История платежей</Title>
      <PaymentList />
    </Space>
  );
};

export default PaymentListPage;
